// extracted by mini-css-extract-plugin
export default {"container":"Mavin_container__n0XC4","logo_container":"Mavin_logo_container__+HvVJ","img_container":"Mavin_img_container__OlCMU"};